// Campos de texto rico da proposta (HTML do editor) — utilitários sem React.

/** O texto tem marcação do editor rico (ou é texto antigo, em linhas)? */
export function isRichHtml(value: string | null | undefined): boolean {
  return /<(p|ul|ol|li|br|strong|b|em|i|u|h3|h4)\b/i.test(value ?? '')
}

/** Texto puro de um campo rico — para exportação, busca e títulos. */
export function richToPlain(value: string | null | undefined): string {
  return (value ?? '')
    .replace(/<\/(p|li|h\d)>/gi, ' ')
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/\s+/g, ' ')
    .trim()
}

/** Texto antigo (uma ideia por linha) vira parágrafos — para abrir no editor. */
export function plainToRichHtml(value: string | null | undefined): string {
  const v = value ?? ''
  if (!v.trim() || isRichHtml(v)) return v
  const esc = (s: string) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  return v.split(/\r?\n/).map(l => l.trim()).filter(Boolean).map(l => `<p>${esc(l)}</p>`).join('')
}

/** Quantas palavras tem um texto rico — vai na linha da tabela no lugar do texto em si. */
export function wordCount(html: string | null | undefined): number {
  const plain = richToPlain(html)
  return plain ? plain.split(/\s+/).length : 0
}
